
const EncounterSummaryCard = ({ title, description, customLabelClass, fontSize }) => {
    // Check if description is a plain string with newlines (not HTML)
    const isPlainTextWithNewlines = typeof description === 'string' && !description.startsWith('<') && description.includes('\n');
    
    return <div>
        <div className="my-4">
            <div className={`font-semibold ${customLabelClass} text-${fontSize}`}>{title}</div>
        </div>
        <div className="bg-padding-box border border-gray-300 rounded-lg shadow-sm p-2">
            <div className="[&_ul]:list-disc [&_ul]:ml-6 [&_ul]:my-2 [&_ol]:list-decimal [&_ol]:ml-6 [&_ol]:my-2 [&_li]:my-1">
                {isPlainTextWithNewlines ? (
                    <pre className="whitespace-pre-wrap font-sans">{description || '-'}</pre>
                ) : (
                    description || '-'
                )}
            </div>
        </div>
    </div>
}

export default EncounterSummaryCard